import {Component, computed, input, signal} from '@angular/core';
import {AutoComplete, AutoCompleteCompleteEvent} from 'primeng/autocomplete';
import {FloatLabel} from 'primeng/floatlabel';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {Message} from 'primeng/message';
import {TranslatePipe} from '@ngx-translate/core';

export interface EmailOption {
  label: string;
  email: string;
}

@Component({
  selector: 'elcia-email-autocomplete',
  imports: [
    AutoComplete,
    FloatLabel,
    ReactiveFormsModule,
    Message,
    TranslatePipe,
  ],
  templateUrl: './email-autocomplete.html',
  styleUrl: './email-autocomplete.scss',
})
export class EmailAutocomplete {
  label = input.required<string>();
  control = input.required<FormControl<string[] | null>>();
  suggestions = input<EmailOption[]>([]);
  isRequired = computed(() => this.control().hasValidator(Validators.required));

  // Le dropdown travaille sur des emails (string) et non des EmailOption : ainsi le modèle reste un
  // string[] propre, que la valeur vienne d'une suggestion, d'un pré-remplissage ou d'une saisie libre.
  protected readonly filtered = signal<string[]>([]);

  // Le modèle ne contient que l'email, donc on retrouve le libellé via les suggestions,
  // sinon on affiche l'email custom tel quel pour éviter un badge vide.
  protected labelFor(email: string): string {
    return this.suggestions().find(option => option.email === email)?.label ?? email;
  }

  protected search(event: AutoCompleteCompleteEvent): void {
    const query = event.query.toLowerCase();
    const selected = this.control().value ?? [];
    this.filtered.set(
      this.suggestions()
        .filter(option => option.label.toLowerCase().includes(query) && !selected.includes(option.email))
        .map(option => option.email),
    );
  }
}
